import { BarChart3, Grip, History, LayoutGrid, List } from 'lucide-react';
import type { Tab } from './navigation';
import { de } from '@/i18n/de';

/** Icon and label per tab, shared by the bottom bar and the sidebar. */
export const TAB_META: Record<Tab, { label: string; Icon: typeof List }> = {
  current: { label: de.tabs.current, Icon: List },
  month: { label: de.tabs.month, Icon: LayoutGrid },
  year: { label: de.tabs.year, Icon: Grip },
  stats: { label: de.tabs.stats, Icon: BarChart3 },
  changes: { label: de.tabs.changes, Icon: History },
};
